import { render, staticRenderFns } from "./OrderDelivery.vue?vue&type=template&id=24091c1e&"
import script from "./OrderDelivery.vue?vue&type=script&lang=js&"
export * from "./OrderDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports